<template>
  <b-card
    no-body
    class="vue-json-query-builder"
    :class="{ 'iq-border-color': isVisible }"
    :style="{ 'pointer-events': loading ? 'none' : 'all' }"
  >
    <b-card-header
      header-text-variant="white"
      header-class="vue-json-query-builder-header iq-bg min-h-45px px-4 d-flex align-items-center"
      @click="isVisible = !isVisible"
    >
      <small class="mr-auto">Rule Builder</small>

      <b-icon-caret-down-fill v-if="isVisible" />
      <b-icon-caret-up-fill v-else />
    </b-card-header>
    <b-card-body class="p-2" v-if="isVisible">
      <RuleGroup
        :current-query="query"
        :options="options"
        :operators="operators"
        :userId="userId"
        ref="ruleGroup"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import RuleGroup from "@/own/components/shipping/courierAssignRules/ruleBuilder/RuleGroup.vue";
export default {
  name: "RuleBuilder",
  components: {
    RuleGroup,
  },
  props: {
    query: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    operators: {
      type: Array,
      required: true,
    },
    userId: {
      required: false,
    },
  },
  data: function () {
    return {
      isVisible: true,
      loading: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.vue-json-query-builder {
  font-size: 12px;
  user-select: none;
  * {
    font-size: 15px !important;
  }
  .vue-json-query-builder-header {
    cursor: pointer;
  }
}
</style>
